<template>
  <div class="editor">
    <div class="editor-content allow-user-select"
      :style="{height:`${editorRect.height}px`,'max-height':`${editorRect.height}px`}">
      <div v-if="reading" class="editor-tips">
        {{$t('core.edit_reading_file')}}{{readPercent?Math.round(readPercent*100)+'%':''}} ......
      </div>
      <div v-else-if="notAllowedEdit" class="editor-tips">
        {{errorMsg}}
        <div style="font-size:14px;margin-top:10px;">
          <a href="javascript:void(0)" @click="onStillEdit">{{$t('core.still_edit')}}</a>
        </div>
      </div>
      <div v-else-if="errorMsg" class="editor-error">{{$t('core.edit_reading_error')}} {{errorMsg}}</div>
      <div v-else ref="container" class="monaco"></div>
    </div>
    <div class="editor-toolbar" v-show="!errorMsg">
      <div class="editor-toolbar-setting">
        <qc-dropdown class="dark-theme drop-left" type="button" trigger="click" direction="up" :closeOnClick="true"
          min-width="180px" max-height="300px">
          {{CHARSET[charset]&&CHARSET[charset].labelShort || charset}}
          <template slot="dropdown">

            <qc-dropdown-item v-for="charsetName in saveCharset" :key="charsetName"
              @click="openWithCharset(charsetName)">
              {{$t('core.open_with_encode_param',{encode: CHARSET[charsetName].labelShort})}}
            </qc-dropdown-item>
            <qc-dropdown-item>
              {{$t('core.open_with_other_encode')}}
              <template slot="dropdown" class="drop-right">
                <qc-dropdown-item v-for="(charsetItem,charsetName) in CHARSET" :key="charsetName"
                  @click="openWithCharset(charsetName)">
                  {{$t('core.open_with_encode_param',{encode: charsetItem.labelShort})}}
                </qc-dropdown-item>
              </template>
            </qc-dropdown-item>

            <qc-dropdown-item v-for="charsetName in saveCharset" :key="charsetName"
              @click="saveWithCharset(charsetName)">
              {{$t('core.convert_to_encode_param',{encode: CHARSET[charsetName].labelShort})}}
            </qc-dropdown-item>
            <qc-dropdown-item>
              {{$t('core.convert_to_other_encode')}}
              <template slot="dropdown">
                <qc-dropdown-item v-for="(charsetItem,charsetName) in CHARSET" :key="charsetName"
                  @click="saveWithCharset(charsetName)">
                  {{$t('core.convert_to_encode_param',{encode: charsetItem.labelShort})}}
                </qc-dropdown-item>
              </template>
            </qc-dropdown-item>

          </template>
        </qc-dropdown>

        <qc-dropdown class="dark-theme" type="button" trigger="click" direction="up" :closeOnClick="true"
          minWidth="170px">
          {{endOfLine}}
          <template slot="dropdown">
            <qc-dropdown-item @click="selectEndOfLine('LF')">LF - Unix and macOS (\n)</qc-dropdown-item>
            <qc-dropdown-item @click="selectEndOfLine('CRLF')">CRLF - Windows (\r\n)</qc-dropdown-item>
          </template>
        </qc-dropdown>

        <qc-dropdown type="button" trigger="click" direction="up" :closeOnClick="true"
          class="editor-language-dropdown dark-theme" filterable>
          {{currLanguage}}
          <template slot="dropdown">
            <qc-dropdown-item v-for="language in languageList" :key="language" @click="selectLanguage(language)"
              :label="language">
            </qc-dropdown-item>
          </template>
        </qc-dropdown>
      </div>

    </div>
  </div>
</template>

<script>
import editorBase from 'src/scripts/mixins/editorBase';

export default {
  mixins: [editorBase],
  props: {
    fileInfo: Object,
    bucketInfo: Object,
    rectSize: Object,
  },
  data() {
    return {
      innerShow: true,
    };
  },
  watch: {
    rectSize() {
      this.initRectRender();
    },
  },
  mounted() {
    this.innerShow = true;
    this.editFile();
  },
  destroyed() {
    this.initData();
  },
  methods: {
    initRectRender() {
      const { height, width } = this.rectSize;
      this.editorRect = {
        width: Math.max(300, width),
        height: height - 30,
      };
    },
  },
};
</script>

<style lang="scss">
.dark-theme.editor-language-dropdown {
  .tc-15-dropdown-menu {
    max-height: 500px;
    overflow-y: auto;
  }
}
</style>
